import type { CommunityMember } from "@circle-react/types";

import { ConnectedButton } from "./ConnectedButton";
import { MessageButton } from "./MessageButton";
import type { ConnectionButtonSize, ConnectionButtonVariant } from "./types";
import { ViewProfileButton } from "./ViewProfileButton";

export interface ActiveStateButtonProps {
  activeStateDisplay?: "message" | "badge";
  closeParent?: () => void;
  fullWidth?: boolean;
  iconOnly?: boolean;
  isCircleV4: boolean;
  isConnectEnabled: boolean;
  member: CommunityMember;
  shouldShowMessageCTA: boolean;
  size?: ConnectionButtonSize;
  variant?: ConnectionButtonVariant;
}

export const ActiveStateButton = ({
  activeStateDisplay,
  closeParent,
  fullWidth,
  iconOnly,
  isCircleV4,
  isConnectEnabled,
  member,
  shouldShowMessageCTA,
  size,
  variant,
}: ActiveStateButtonProps) => {
  const connectedButtonProps = isCircleV4 ? { fullWidth } : { size };
  const messageButtonProps = isCircleV4
    ? { iconOnly, fullWidth }
    : { variant, size };
  const viewProfileProps = isCircleV4 ? { fullWidth } : { variant, size };

  if (activeStateDisplay === "badge" && isConnectEnabled) {
    return <ConnectedButton {...connectedButtonProps} />;
  }
  if (shouldShowMessageCTA) {
    return (
      <MessageButton
        memberId={member.id}
        closeParent={closeParent}
        {...messageButtonProps}
      />
    );
  }
  return <ViewProfileButton member={member} {...viewProfileProps} />;
};
